/* eslint-disable */
<template>
  <div class="">
    <el-form label-width="120px">
      <el-form-item label="企业名称" required="">
        <el-tag v-show="corp_name">{{ corp_name }}</el-tag>
        <el-tag style="margin-left: 8px" effect="dark" :disabled="isEdit" @click="changeSource">{{ corp_name ? '修改' : '选择' }}</el-tag>
        <!-- <el-select v-model="corp_id" placeholder="请选择" :disabled="isEdit">
          <el-option v-for="item in corpidoptions" :key="item.corp_id" :label="item.corp_name" :value="item.corp_id" />
        </el-select> -->
      </el-form-item>

      <el-form-item label="发送时间">
        <el-time-select
          v-model="corn_time"
          :picker-options="{
            start: '00:00',
            step: '00:15',
            end: '23:45'
          }"
          placeholder="选择时间"
        />
      </el-form-item>

      <el-form-item label="" style="height: 10px">
        <el-button type="primary" @click="confirm">确定</el-button>
      </el-form-item>
    </el-form>

    <el-dialog title="企业列表" :visible.sync="enterlistVisible" :destroy-on-close="true" width="30%" :close-on-click-modal="false" :append-to-body="true">
      <enterlist ref="soucelistview" @labelchoose="labelchoose" />
    </el-dialog>
  </div>
</template>

<script>
import { boundUpdate, boundCreate } from '@/api/tencentAccountIni'
import enterlist from './enterlist.vue'

export default {
  components: { enterlist },
  props: {
    report_template_id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      corp_id: null,
      corn_time: null,
      corn_time_text: null,
      corp_name: null,
      corpidoptions: [],
      isEdit: false,
      id: null,
      enterlistVisible: false
    }
  },
  created() {},
  methods: {
    send(row) {
      if (row) {
        this.isEdit = true
        this.id = row.id
        this.corp_id = row.corp_id
        this.corn_time = row.corn_time_text
        this.corp_name = row.corp_name
      }
    },
    changeSource() {
      this.enterlistVisible = true
    },
    labelchoose(backitem) {
      this.enterlistVisible = false
      this.corp_name = backitem.corp_name
      this.corp_id = backitem.corp_id
    },
    async confirm() {
      if (!this.corp_name) {
        this.$message({
          message: '请选择企业',
          type: 'error'
        })
        return
      }
      if (!this.corn_time) {
        this.$message({
          message: '请选择添加汇报时间',
          type: 'error'
        })
        return
      }

      if (this.isEdit) {
        const result = {
          id: this.id,
          corn_day: 0,
          corn_time: this.corn_time
        }
        await boundUpdate(result)
        this.$emit('update')
      } else {
        const result = {
          corp_id: this.corp_id,
          report_template_id: this.report_template_id,
          corn_day: 0,
          corn_time: this.corn_time
        }
        await boundCreate(result)
        this.$emit('update')
      }
    }
  }
}
</script>

<style scoped>
.erBox {
  width: 100px;
  height: 100px;
  border: 1px solid #ccc;
  cursor: pointer;
  position: relative;
}

.erBox::before {
  content: '';
  position: absolute;
  width: 1px;
  height: 50px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox::after {
  content: '';
  position: absolute;
  width: 50px;
  height: 1px;
  background-color: #ccc;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.erBox:hover {
  border-color: rgb(7, 123, 201);
}

.erBox:hover::after,
.erBox:hover::before {
  background-color: rgb(7, 123, 201);
}

.file {
  display: none;
}

.imgBox {
  width: 100px;
  height: 100px;
  position: relative;
}

.imgBox:hover span {
  display: inline-block !important;
}

.imgBox span {
  width: 100%;
  height: 100%;
  background-color: rgba(200, 200, 200, 0.5);
  position: absolute;
  z-index: 11;
  left: 0px;
  display: none;
}

.myi {
  cursor: pointer;
  font-size: 25px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.el-form-item{
  overflow:visible;
}
</style>
